import { HotkeysProvider } from '@tanstack/react-hotkeys'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { createRouter, RouterProvider } from '@tanstack/react-router'
import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { routerSearch } from './components/search/routerSearch'
import { routeTree } from './routeTree.gen'

const router = createRouter({
  routeTree,
  trailingSlash: 'never',
  // Pretty share URLs — decode safe punctuation in the query string.
  parseSearch: routerSearch.parse,
  stringifySearch: routerSearch.stringify,
})

// Register the router instance for full type-safety across the app.
declare module '@tanstack/react-router' {
  interface Register {
    router: typeof router
  }
}

const queryClient = new QueryClient()

const root = document.getElementById('root')
if (!root) throw new Error('Root element not found')
createRoot(root).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <HotkeysProvider>
        <RouterProvider router={router} />
      </HotkeysProvider>
    </QueryClientProvider>
  </StrictMode>,
)
